import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48a984d9&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a984d9')) {
      api.createRecord('48a984d9', component.options)
    } else {
      api.reload('48a984d9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=48a984d9&", function () {
      api.rerender('48a984d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profil/index.vue"
export default component.exports